/**
 *
 * @param {object|null} provider
 * @param {object|null} service
 * @param {string|null} errorProvider
 * @param {boolean} isLoadingProvider
 * @returns {boolean|*}
 */
export const getSyncModeMin = (provider, service, errorProvider, isLoadingProvider) => {
  if (!service) {
    return false;
  }
  if (errorProvider || isLoadingProvider) {
    return false;
  }
  if (provider?.hasOwnProperty('service_auto_increment')) {
    return provider.service_auto_increment;
  }
  return false;
};

/**
 *
 * @param {object|null} provider
 * @param {object|null} service
 * @param {string|null} errorProvider
 * @param {boolean} isLoadingProvider
 * @returns {boolean|*}
 */
export const getSyncModeMax = (provider, service, errorProvider, isLoadingProvider) => {
  if (!service) {
    return false;
  }
  if (errorProvider || isLoadingProvider) {
    return false;
  }
  if (provider?.hasOwnProperty('service_auto_max')) {
    return provider.service_auto_max;
  }
  return false;
};
